import {utilHelper} from "../../_helpers";

const relativeUrl = '/api/user'

export const userService = {
    search,
    getItem,
    saveItem,
    updateItem,
    deleteItem,
    changeMyPassword,
    resetPassword,

    getList,
    getAll,
    getPagedList,
    listAllUserExcludeCurrentLogin,
    hasRoleAdmin,
    getCurrentUserInfo
};

function search(offset, max, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data, showAlert: false })
}

function getItem(id) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'GET', { showAlert: false })
}

function saveItem(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', {data});
}

function updateItem(id, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', {data});
}

function deleteItem(id) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'DELETE', { })
}

function getPagedList(offset, max) {
    return utilHelper.doRequest(`${relativeUrl}?max=${max}&offset=${offset}`, 'GET')
}

function getAll() {
    return utilHelper.doRequest(`${relativeUrl}/getAll`, 'GET')
}

function getList() {
    return utilHelper.doRequest(`${relativeUrl}`, 'GET')
}

function changeMyPassword(oldPassword, password) {
    return utilHelper.doRequest(`${relativeUrl}/changeMyPassword/${oldPassword}&${password}`, 'POST')
}

function resetPassword(username, password) {
    return utilHelper.doRequest(`${relativeUrl}/resetPassword/${username}&${password}`, 'POST')
}

function listAllUserExcludeCurrentLogin() {
    return utilHelper.doRequest(`${relativeUrl}/listAllUserExcludeCurrentLogin`, 'GET')
}

function hasRoleAdmin(currentUser) {
    let result = false;
    currentUser.roles.forEach(element => {
        if (element == 'ROLE_ADMIN') {
            result = true;
            return;
        }
    })
    return result;
}

function getCurrentUserInfo(){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/getCurrentUserInfo`, 'GET',{showAlert:false})
}